/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Redux
import { RootReducerState } from "../reducers";

export const ordersSelector = (state: RootReducerState) => state.account.orders;

const addressDetailsSelector = (state: RootReducerState) => state.account.address;
const accountLoadingSelector = (state: RootReducerState) => state.account.isLoading;
const accountUpdatedSelector = (state: RootReducerState) => state.account.accountUpdated;

export { addressDetailsSelector, accountLoadingSelector, accountUpdatedSelector };
